/**
 * 应用根组件，负责初始化路由与全局 Socket。
 */
import { useEffect, useRef } from "react";
import { useRoutes } from "react-router-dom";
import { Toaster } from "sonner";
import {
	initializeSocket,
	socket,
	useSocketStore,
} from "@/services/remote/socket";
import { useDebugStore } from "@/stores/remote";
import router from "./router";

/**
 * 根组件，挂载路由与调试面板。
 */
function App() {
	const hasInitialized = useRef(false);
	const cleanupRef = useRef<(() => void) | null>(null);

	useEffect(() => {
		useDebugStore.getState().initDebugCommands();
	}, []);

	const content = useRoutes(router);

	useEffect(() => {
		// 防止在严格模式下重复执行
		if (!hasInitialized.current) {
			hasInitialized.current = true;

			console.log("Initializing socket...");
			initializeSocket().then((cleanup) => {
				cleanupRef.current = cleanup || null;
			});
		}

		return () => {
			const { isConnected } = useSocketStore.getState();

			// 只有在 socket 已经连接的情况下才清理
			// 这样可以避免在 StrictMode 下过早断开连接
			if (isConnected || socket.connected) {
				console.log("cleanup and disconnect socket");
				cleanupRef.current?.();
				cleanupRef.current = null;
				socket.disconnect();
			}
		};
	}, []);

	return (
		<>
			{content}
			{/* {showDebugInfo && <Client />} */}
			<Toaster />
		</>
	);
}

export default App;
